/**
 * Lokace správy textací
 */
export enum ParagraphLocation {
  /**
   * Domovská stránka
   */
  HOMEPAGE = 'HOMEPAGE',
}
